import Vue from 'vue';
import notificationService from '@/services/notificationService';
import { Module } from 'vuex';
import groupsService from '@/services/graph/groupsService';
import settings from '@/settings.json';
import { SecurityConfig } from "@/installationConfig";
import { EmployeesClient } from '@/data/web-api-client';

const employeesModule: Module<any, any> = {
    namespaced: true,
    state: {
        loading: true,
        initialised: false,
        items: [],
    },
    getters: {
        items: (state) => state.items,
        itemByUserId: (state) => (id: string) => state.items.find((o: any) => o.id === id),
        loading: (state) => state.loading,
    },
    mutations: {
        setItems(state, objects) {
            state.initialised = true;
            state.items = objects;
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setSaving(state, value) {
            state.saving = value;
        },
    },
    actions: {
        async fetch({ dispatch, state }, { axios }) {
            if (!state.initialised) {
                await dispatch('load', { axios });
            }
        },
        async load({ commit, dispatch }, { axios }) {
            commit('setLoading', true);
            try {
                const res = await new EmployeesClient(undefined, axios).getEmployeesFromO365();
                commit('setItems', res.filter((x:any) => x.accountEnabled == true));
            } catch (err) {
                notificationService.failedToLoad();
                await dispatch('load');
            } finally {
                commit('setLoading', false);
            }
        },
    },
};

export default employeesModule;
